import PrecinctCard from './precinct-card'

export default PrecinctCard
